import * as PnpDocActions from '../../pnp-doc.actions'
import { pdfClientId } from '../../../../../../bootstrap.json';
import * as PnpDocsActions from '../../../pnp-docs.actions'
import { IDS } from '../../pnp-doc.constants';
/**
 * @const {object}
 * @memberOf module:policies
 */
export const pnpDocHistoryDetails = {
    /* @ngInject */
    controller: function ($ngRedux, DocumentManager, AuthService) {
        const unsubscribe = $ngRedux.connect(({ policies }) => ({
            pnpDocument: policies.pnpDocument
        }), {
            ...PnpDocActions,
            ...PnpDocsActions
        })(this);

        /**
           * @function $onInit
           */
        this.$onInit = () => {

            this.title = 'Document View'
            this.unsavedChanges = false;
            this.script = null;

            this.stateIdentifier = 'pnpDocument';
            this.identifier = IDS.app_policies_documents_manage;
            this.state = IDS.app_policies_documents_manage_history_details;

            if (!window.adobe_dc_sdk || !window.adobe_dc_sdk["dc-core-loaded"]) {
                this.loadAdobeScript();
            } else {
                this.initializeAdobeViewer();
            }
        }

        this.loadAdobeScript = () => {
            this.script = document.createElement('script');
            this.script.src = "https://documentcloud.adobe.com/view-sdk/viewer.js";
            document.head.appendChild(this.script);

            this.script.onload = () => {
                // Initialize Adobe PDF Viewer after the script is loaded
                this.initializeAdobeViewer();
            };
        }


        this.initializeAdobeViewer = () => {
            if (document.readyState === "complete" && window.AdobeDC) {
                this.loadPDFView();
            } else {
                document.addEventListener("adobe_dc_view_sdk.ready", () => this.loadPDFView());
            }
        }

        this.loadPDFView = () => {
            const pdfCtrl = this;
            const pdfId = "77c6fa5d-6d74-4104-8349-657c8411a834";
            const pdfUrl = DocumentManager.toURL(this.pnpDocument.pdfPath)
            const user = AuthService.getUser();

            const profile = {
                userProfile: {
                    name: user.name,
                    firstName: user.name,
                    lastName: user.name
                }
            };

            let annotationManager;
            const adobeDCView = new AdobeDC.View({
                clientId: pdfClientId,
                divId: "adobe-dc-view"
            });

            const previewFilePromise = adobeDCView.previewFile({
                content: { location: { url: pdfUrl } },
                metaData: { fileName: "viewer.pdf", id: pdfId }
            }, {
                enableAnnotationAPIs: true,
                includePDFAnnotations: true,
                showAnnotationTools: true
            });

            adobeDCView.registerCallback(
                AdobeDC.View.Enum.CallbackType.GET_USER_PROFILE_API,
                () => {
                    return new Promise((resolve, reject) => {
                        resolve({
                            code: AdobeDC.View.Enum.ApiResponseCode.SUCCESS,
                            data: profile
                        });
                    });
                }
            );

            previewFilePromise.then(adobeViewer => {
                adobeViewer.getAnnotationManager().then(manager => {
                    annotationManager = manager;

                    // Apply annotations from backend when viewer is loaded
                    pdfCtrl.applyAnnotations = async function () {

                        if (pdfCtrl.pnpDocument.comment && pdfCtrl.pnpDocument.comment.length > 0) {
                            try {
                                const annotations = pdfCtrl.pnpDocument.comment;
                                if (Array.isArray(annotations) && annotations.length > 0) {
                                    await annotationManager.addAnnotations(annotations);
                                    console.log("Annotations applied from backend:", annotations);
                                } else {
                                    console.log("No annotations to apply.");
                                }
                            } catch (error) {
                                console.error("Failed to apply annotations:", error);
                            }
                        }
                    };

                    // Apply annotations from backend when viewer is loaded
                    pdfCtrl.applyAnnotations();
                });
            }).catch(function (error) {
                console.error("Failed to load PDF or enable annotation APIs:", error);
            });
        }

        /**
         * @function $onDestroy
         */
        this.$onDestroy = () => {
            unsubscribe();
            document.removeEventListener("adobe_dc_view_sdk.ready", () => this.loadPDFView());
        }
    },
    template: require('./pnp-doc-history-details.html')
}
